import { TOKEN, CobranzasAxios, COMPANY } from './config';

export const getCompanyStatus = async (roles) => {
  const res = await CobranzasAxios.post(`/information/${COMPANY}`, { roles }, { headers: { Authorization: TOKEN } });
  return res.data;
};
